// app/packs/member/redux/modules/remOpportunityComparison.js

const SET_SEARCH_RESULTS = "remOpportunityComparison/SET_SEARCH_RESULTS";
const SET_COMPARISON_DATA = "remOpportunityComparison/SET_COMPARISON_DATA";
const ADD_COMPARISON = "remOpportunityComparison/ADD_COMPARISON";
const REMOVE_COMPARISON = "remOpportunityComparison/REMOVE_COMPARISON";
const UPDATE_COMPARISON = "remOpportunityComparison/UPDATE_COMPARISON";
const CLEAR_ALL = "remOpportunityComparison/CLEAR_ALL";

const initialState = {
  searchResults: [], // Store the searched companies
  comparisons: [], // Array of comparison objects - start with no default
  comparisonData: {}, // Store actual comparison results by comparison ID
  loading: false,
  loaded: false,
  errors: [],
};

export function setSearchResults(results) {
  return {
    type: SET_SEARCH_RESULTS,
    payload: results,
  };
}

export function setComparisonData(comparisonId, data) {
  return {
    type: SET_COMPARISON_DATA,
    payload: { comparisonId, data },
  };
}

export function addComparison() {
  return {
    type: ADD_COMPARISON,
  };
}

export function removeComparison(id) {
  return {
    type: REMOVE_COMPARISON,
    payload: { id },
  };
}

export function updateComparison(id, updates) {
  return {
    type: UPDATE_COMPARISON,
    payload: { id, updates },
  };
}

export function clearAll() {
  return {
    type: CLEAR_ALL,
  };
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type } = action;

  switch (type) {
    case SET_SEARCH_RESULTS:
      return {
        ...state,
        searchResults: payload,
        loaded: true,
      };
    case SET_COMPARISON_DATA: {
      const { comparisonId, data } = payload;
      return {
        ...state,
        comparisonData: {
          ...state.comparisonData,
          [comparisonId]: data,
        },
      };
    }
    case ADD_COMPARISON: {
      const currentComparisons = state.comparisons;
      let newId = 0;
      if (currentComparisons.length > 0) {
        const lastComparison =
          currentComparisons[currentComparisons.length - 1];
        newId = lastComparison.id + 1;
      }
      return {
        ...state,
        comparisons: [...currentComparisons, { id: newId }],
      };
    }
    case REMOVE_COMPARISON: {
      const { id } = payload;
      const filteredComparisons = state.comparisons.filter(
        (item) => item.id !== id
      );
      const newComparisonData = { ...state.comparisonData };
      delete newComparisonData[id];
      return {
        ...state,
        comparisons: filteredComparisons,
        comparisonData: newComparisonData,
      };
    }
    case UPDATE_COMPARISON: {
      const { id, updates } = payload;
      const updatedComparisons = state.comparisons.map((comp) =>
        comp.id === id ? { ...comp, ...updates } : comp
      );
      return {
        ...state,
        comparisons: updatedComparisons,
      };
    }
    case CLEAR_ALL:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
